module.exports = __webpack_public_path__ + "img/titulo-biblioteca.abe0c0ad.png";